import React, { useState } from "react";

const SparePartsKeys_ProductListItem = ({ availability, sparePart, getAddToCartButton, priceElement, deliveryDate, notInAssortment, translations, isKeysAndLocks }) => {
    const [show, setShow] = useState(false);
    const isExtranet = _THULEDATA.SitecoreSiteName === "Extranet";
    return <div className="w-100 spm__productListItem p-0">
        <button onClick={() => setShow(!show)} className="w-100 btn p-0"><div className="d-flex justify-content-between py-4 align-items-center"><p className="heading6 m-0">{(!isKeysAndLocks && sparePart.Badge) && <span>{sparePart.Badge}. </span>}<span className="productName">{sparePart.Name}</span></p> <div className="d-flex"><i className={`le-icon-chevron ${show ? "rot-90" : "rot-270"}`}></i></div></div></button>
        {show && <div className="d-flex flex-column align-items-start paragraph--s mb-4">
            <div className="paragraph--s mb-4 itemContent">
                <span className="text-color--gray80">{translations.ArticleNumber}</span> {sparePart.Id}
            </div>
            {notInAssortment ? <div className="paragraph--s mb-4 itemContent">
                <span className="text-color--gray80 w-100">{translations?.NotInAssortment}</span>
            </div> : <><div className="paragraph--s mb-4 itemContent">
                <span className="text-color--gray80">{isExtranet ? `${translations.Price}/${translations.RRP}` : translations.Price}</span>{priceElement}
            </div>
                {deliveryDate && <div className="paragraph--s mb-4 itemContent">
                    <span className="text-color--gray80">{translations?.Available}</span><div>{availability && <span className="me-4">{availability}</span>}{deliveryDate}</div>
                </div>}
                {getAddToCartButton(sparePart)}
            </>}
        </div>}
    </div>
}
export default SparePartsKeys_ProductListItem;